import { css, cva } from "@stubhub/broadway-foundation/css";

export const sectionContainer = css({
  display: "flex",
  flexDirection: "column",
});

export const stickyContainer = css({
  position: "sticky",
  insetBlockStart: "primitives.0",
  insetInline: "primitives.0",
  backgroundColor: "bg.surface",
  zIndex: "[1]",
  transform: "translateZ(0)",
  willChange: "transform",
  borderBlockEndWidth: "primitives.25",
  borderBlockEndStyle: "solid",
  borderBlockEndColor: "border",
});

export const filterRowRecipe = cva({
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "primitives.100",
    rowGap: "primitives.100",
    backgroundColor: "bg.surface",
    paddingBlockEnd: "primitives.150",
  },
  variants: {
    position: {
      static: { paddingBlockStart: "primitives.50" },
      stuck: { paddingBlockStart: "primitives.150" },
    },
  },
  defaultVariants: { position: "static" },
});

export const dateControl = css({
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: "primitives.0",
});

export const rightControls = css({
  display: "flex",
  alignItems: "center",
  columnGap: "primitives.100",
  rowGap: "primitives.100",
  flexShrink: 0,
});

export const eventTypeControl = css({
  flexShrink: 0,
});

export const filterIconControl = css({
  flexShrink: 0,
});

export const dateButton = css({});

export const chipSubtleClasses = {
  label: css({ color: "text.subtle" }),
  icon: css({ color: "text.subtle" }),
};
